import React, { useState, useEffect, useRef, useContext } from 'react'
import classNames from 'classnames'
import {
    Spacer,
    Field,
    Button,
    Radio,
    Label,
    Divider,
    Checkbox,
    Card,
    Icon,
    Row,
    Col,
    Collapse
} from '@cleartrip/bento'
import Modal from 'lib/Modal'
import ModalHeader from '../UserProfileModalHeader'
import Dropdown from 'components/Dropdown'
import langTranslate from 'locale'
import OfflineToast from 'components/GlobalNav/UserProfile/offlineToast'
import { ReactComponent as TickFill } from 'assets/icons/green-tick.svg'
import { isEmpty } from 'utils/browserHelper'
import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { onlyNumbersRegex } from 'utils/flights/itinerary'
import { submitPersonalDetails, saveNudge } from 'api/flights/results'
import { errorConfig } from './errorConfig'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'
import { resolveKeysInObjectsArrays } from 'utils/browserHelper'

const PersonalDetails = ({
    toggle,
    travelCheckedStatus,
    setTravelCheckedStatus,
    changeFirstNameHandler,
    isValidFirstName,
    firstName,
    validateFirstNameHandler,
    changeLastNameHandler,
    isValidLastName,
    lastName,
    validateLastNameHandler,
    gender,
    setGender,
    errorInfo,
    toggleModalAndClosePage
}) => {
    const [personalDetailsError, setPersonalDetailsError] = useState(false)
    const [apiError, setApiError] = useState('')
    const [loading, setLoading] = useState(false)

    const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
    const pathname = query.split('/')
    const pagePath = pathname[2]

    const checkHiFiveFlow = () => {
        const retVal =
            pathname &&
            pathname.length > 2 &&
            pathname[1] === 'ref' &&
            !isEmpty(pathname[2]) &&
            pathname[2] != 'null' &&
            pathname[2] != 'undefined'
        return retVal
    }

    const isHiFiveFlow = checkHiFiveFlow()

    useEffect(() => {
        ClevertapEvent({
            actionName: 'Profile_details_modal_opened',
            actionType: 'Button',
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',

            currentPage: pagePath
        })
    }, [])

    const submitDetails = async () => {
        try {
            const payload = {
                marketingSubscription: 0,
                personalData: {
                    firstName: firstName,
                    lastName: lastName,
                    gender: gender
                }
            }
            const response = await submitPersonalDetails(payload)
            const { status, data, error } = response || {}
            if (status === 200) {
                ClevertapEvent({
                    actionName: 'Profile_details_submitted',
                    actionType: 'Button',
                    page:
                        pagePath === 'results'
                            ? 'SRP'
                            : isEmpty(pagePath) || isHiFiveFlow
                            ? 'HP'
                            : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                            ? 'Itinerary'
                            : 'Confirmation_Page',

                    currentPage: pagePath,
                    send_me_offer_details_check_box: travelCheckedStatus ? 'Y' : 'N'
                })
                if (isHiFiveFlow) {
                    toggleModalAndClosePage(false)
                } else {
                    toggleModalAndClosePage()
                }
            } else {
                const { response = { data: {} } } = error || {}
                const { data = {} } = response
                const { message } = data
                const err = errorConfig[message] || errorConfig.default
                setApiError(err)
            }
        } catch (e) {
            console.log('Submit details api error', e)
            setApiError(errorConfig.default)
        }
    }

    const onDone = async () => {
        setLoading(true)
        let errorNudge = false
        if (isEmpty(firstName) && isEmpty(lastName) && isEmpty(gender)) {
            errorNudge = true
        }
        const isFirstNameValid = isEmpty(firstName) ? true : validateFirstNameHandler(firstName)
        const isLastNameValid = isEmpty(lastName) ? true : validateLastNameHandler(lastName)
        setPersonalDetailsError(errorNudge)
        if (isFirstNameValid && isLastNameValid) {
            if (!errorNudge) {
                submitDetails()
            }
        } else {
            if (!isFirstNameValid || !isLastNameValid) {
                ClevertapEvent({
                    actionName: 'Invalid_value_entered',
                    actionType: 'Button',
                    page:
                        pagePath === 'results'
                            ? 'SRP'
                            : isEmpty(pagePath) || isHiFiveFlow
                            ? 'HP'
                            : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                            ? 'Itinerary'
                            : 'Confirmation_Page',

                    currentPage: pagePath,
                    field_name: `${!isFirstNameValid ? 'first name' : ''} ${!isLastNameValid ? 'last name' : ''}`,
                    form_name: 'profile_details'
                })
                setLoading(false)
                return
            }
        }
        setLoading(false)
    }

    function changeFirstName(e) {
        setPersonalDetailsError('')
        setApiError('')
        changeFirstNameHandler(e)
    }
    function changeLastName(e) {
        setPersonalDetailsError('')
        setApiError('')
        changeLastNameHandler(e)
    }

    return (
        <div
            className="bg-white br-4 br-4 o-hidden d-flex flex-column"
            style={{
                width: '400px',
                // minHeight: '80vh',

                height: '468px'
            }}
        >
            <div
                className={`px-8 d-flex flex-1 flex-column`}
                // onKeyDown={e => {
                //     if (e.key === 'Enter') {
                //         onDone()
                //     }
                // }}
            >
                {/* <ModalHeader title={} toggle={toggle} showCloseButton={false} /> */}
                <div className="pt-6 pb-6">
                    <div className="flex flex-between flex-middle">
                        <span className="fs-7 fw-600 c-neutral-900">{'Almost there..'}</span>
                    </div>
                </div>
                <Spacer className="mb-1" />

                <div className="flex flex-1 flex-column">
                    <div className="flex flex-1 flex-column  mb-10" style={{ maxHeight: 'calc(100vh - 250px)' }}>
                        <OfflineToast page="proceed" />
                        {personalDetailsError && (
                            <>
                                <div className="py-2 px-2 h-8 flex flex-middle bg-error-600 c-white fs-2 br-4 ">
                                    <InfoIcon className="c-white" height={16} width={16} />
                                    <span data-testid="signinError" className={errorInfo}>
                                        {'Please fill all the empty fields or select skip'}
                                    </span>
                                </div>
                                <Spacer className="pt-4" />
                            </>
                        )}
                        {apiError && (
                            <>
                                <div className="py-2 px-2 h-8 flex flex-middle bg-error-600 c-white fs-2 br-4 ">
                                    <InfoIcon className="c-white" height={16} width={16} />
                                    <span data-testid="signinError" className={errorInfo}>
                                        {apiError}
                                    </span>
                                </div>
                                <Spacer className="pt-4" />
                            </>
                        )}

                        <div className="d-flex flex-column mb-7">
                            <div className="c-neutral-700 fs-3 mb-2">Your name</div>
                            <Field
                                placeholder="First Name"
                                className=" lh-title "
                                onChange={changeFirstName}
                                value={firstName}
                                hasError={!isValidFirstName && firstName.length > 0}
                            />
                            {!isValidFirstName && firstName.length > 0 && (
                                <div data-testid="firstNameFieldInvalid" className="c-error-500 fs-2 mt-1">
                                    {'Please enter a valid first name'}
                                </div>
                            )}
                            <Spacer className="mb-4" />
                            <Field
                                type="email"
                                placeholder="Last Name"
                                className=" lh-title"
                                onChange={changeLastName}
                                value={lastName}
                                hasError={!isValidLastName && lastName.length > 0}
                            />

                            {!isValidLastName && lastName.length > 0 && (
                                <div data-testid="lastNameFieldInvalid" className="c-error-500 fs-2 mt-1">
                                    {'Please enter a valid last name'}
                                </div>
                            )}
                        </div>

                        <div className="d-flex flex-column mb-4">
                            <div className="c-neutral-700 fs-3 mb-2">Gender</div>
                            <div className="d-flex flex-row">
                                <div className="mr-9">
                                    <Radio
                                        name="gender"
                                        onClick={() => {
                                            setPersonalDetailsError('')
                                            setApiError('')
                                            setGender('MALE')
                                        }}
                                        // onChange={() => genderClickHandler('FEMALE')}
                                        checked={gender === 'MALE'}
                                    >
                                        <span className="ml-2 fs-3 c-neutral-700">Male</span>
                                    </Radio>
                                </div>
                                <div className="mr-9">
                                    <Radio
                                        name="gender"
                                        onClick={() => {
                                            setPersonalDetailsError('')
                                            setApiError('')
                                            setGender('FEMALE')
                                        }}
                                        // onChange={() => genderClickHandler('FEMALE')}
                                        checked={gender === 'FEMALE'}
                                    >
                                        <span className="ml-2 fs-3 c-neutral-700">Female</span>
                                    </Radio>
                                </div>
                                <div className="mr-9">
                                    <Radio
                                        name="gender"
                                        onClick={() => {
                                            setPersonalDetailsError('')
                                            setApiError('')
                                            setGender('OTHER')
                                        }}
                                        // onChange={() => genderClickHandler('FEMALE')}
                                        checked={gender === 'OTHER'}
                                    >
                                        <span className="ml-2 fs-3 c-neutral-700">Other</span>
                                    </Radio>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-column mb-6">
                        <div className="mb-4">
                            <Button
                                size="md"
                                type="secondary"
                                full
                                onClick={() => {
                                    onDone()
                                }}
                                busy={loading}
                                disabled={isEmpty(firstName) && isEmpty(lastName) && isEmpty(gender)}
                                // onClick={() => goBackAnimation(USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE)}
                            >
                                <span className="fs-3 fw-550">{langTranslate('Done')}</span>
                            </Button>
                            <div className="ta-center fs-3 fw-600 c-blue c-pointer mt-4" onClick={() => {
                                toggle()
                            }}>
                            Not now
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PersonalDetails
